import React, { ReactElement } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Blog } from '../../../structures/models/blog';
import { BLOG_DEFAULT_IMAGE } from '../../../utils/constants';
import { setFallbackImage } from '../../../utils/imageHelper';

export interface BreedArticleCardInterface extends Pick<Blog,
  'id' | 'title' | 'excerpt' | 'banner_image_url' | 'route'
> { }

interface BreedArticleCardProps {
  article: BreedArticleCardInterface;
}

const BreedArticleCard: React.FC<BreedArticleCardProps> = ({ article }): ReactElement => {
  return (
    <>
      <a className="breed-article-card" href={article.route}>
        <div className="card custom-card p-4">
          <LazyLoadImage
            onError={(e) => {
              setFallbackImage(e, BLOG_DEFAULT_IMAGE);
            }}
            src={article.banner_image_url ?? BLOG_DEFAULT_IMAGE}
            className="card-img-top object-fit-cover"
            alt={article.title}
          />
          <div className="card-body">
            <h5 className="card-title">{article.title}</h5>
            <div className="puppy-description my-0">{article.excerpt}</div>
          </div>
        </div>
      </a>
    </>
  );
};

export default BreedArticleCard;
